<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.task.name"
                  label="Name"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.name'),
                      serverSideErrors('Name')
                    )
                  "
                  @blur="$v.form.task.name.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <client-select
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.clientId'),
                      serverSideErrors('ClientId')
                    )
                  "
                  v-model="form.task.clientId"
                  label="Select Client"
                  @blur="$v.form.task.clientId.$touch()"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <date-picker
                  v-model="form.task.date"
                  label="Date"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.date'),
                      serverSideErrors('Date')
                    )
                  "
                  @blur="$v.form.task.date.$touch()"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <time-picker v-model="form.task.time" label="Time"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.time'),
                      serverSideErrors('Time')
                    )
                  "
                  @blur="$v.form.task.time.$touch()" />
              </v-col>
              <!-- <v-col cols="12" sm="12" md="12">
                <v-text-field
                  type="number"
                  v-model="form.task.rate"
                  label="Pay Rate / Hour"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.rate'),
                      serverSideErrors('Rate')
                    )
                  "
                  @blur="$v.form.task.rate.$touch()"
                />
              </v-col> -->
              <v-col cols="12" sm="12" md="12">
                <user-select
                  v-model="form.userIds"
                  label="Assign To"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.userIds'),
                      serverSideErrors('UserIds')
                    )
                  "
                  :hide-details="
                    [].concat(
                      fieldErrors('form.userIds'),
                      serverSideErrors('UserIds')
                    ).length == 0
                  "
                  @blur="$v.form.userIds.$touch()"
                  :multiple="true"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="form.task.type"
                  :items="typeOptions"
                  item-text="text"
                  item-value="value"
                  label="Type"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.type'),
                      serverSideErrors('Type')
                    )
                  "
                  @blur="$v.form.task.type.$touch()"
                />
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <tags-select
                  v-model="form.task.tags"
                  label="Tags"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.tags')
                    )
                  "
                  @blur="$v.form.task.tags.$touch()"
                />
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="form.task.description"
                  label="Description"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.description'),
                      serverSideErrors('Description')
                    )
                  "
                  @blur="$v.form.task.description.$touch()"
                  rows="3"
                  auto-grow
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Edit" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import ClientSelect from "src/components/ClientSelect.vue";
import DatePicker from "src/components/DatePicker.vue";
import TimePicker from "components/TimePicker.vue";
import UserSelect from "src/components/UserSelect";
import moment from "moment";
import formatterMixin from "@/mixins/formatterMixin";
import TagsSelect from 'components/TagSelect.vue';

const defaultInputs = {
  task: {
    id: "",
    name: "",
    status: "open",
    type: "Labor",
    date: moment().format("yyyy-MM-DD"),
    time: moment().format("HH:mm"),
    description: "",
    clientId: "",
    rate: 0,
    tags: []
  },
  userIds: [],
};

export default {

  components: {
    AlertMessage,
    ClientSelect,
    DatePicker,
    UserSelect,
    TimePicker,
    TagsSelect
  },
  props: {
    clientId: Number,
    item: Object,
    show: [Boolean, String],
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      userIds: { required },
      task: {
        name: {
        },
        status: { required },
        type: { required },
        date: { required },
        time: { required },
        clientId: { required },
        description: { },
        rate: {},
        tags: {}
      },
    },
  },
  validationMessages: {
    form: {
      userIds: { required: "Required" },
      task: {
        name: {
          required: "Required",
        },
        status: {
          required: "Required",
        },
        type: {
          required: "Required",
        },
        date: {
          required: "Required",
        },
        time: {
          required: "Required",
        },
        description: {
          required: "Required",
        },
        clientId: {
          required: "Required",
        },
        rate: {},
        tags: {}
      },
    },
  },

  data() {
    return {
      showDialog: this.show,

      form: {
        ...defaultInputs,
        task: {
          ...defaultInputs.task,
          clientId: this.clientId,
        },
      },

      typeOptions: [
        { value: "remote", text: "Remote Support" },
        { value: "onsite", text: "Onsite Support" },
      ],

      statusOptions: [
        { value: "open", text: "Open" },
        { value: "closed", text: "Closed" },
        { value: "complete", text: "Complete" },
      ],

      dialog: false,
      valid: false,
      loading: false,
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },

    item(n, o) {
      if (n && JSON.stringify(n) !== JSON.stringify(o)) {
        let userIds = [];
        if (n.taskUsers) {
          userIds = n.taskUsers.map((user) => user.userId);
        }
        this.form = {
          task: {
            ..._.pick(n, _.keys(defaultInputs.task)),
            time: this.formatDatetime(n.date).split(' ')[1]
          },
          userIds,
        };
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      task: (state) => state.task,
      alert: (state) => state.alert,
    }),
    formTitle() {
      return this.isEdit ? "Edit Time Clock" : "Add Time Clock";
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
    taskId() {
      return UTIL.gv(this.item, "id", "");
    },
  },

  methods: {
    ...mapActions("task", ["create", "update"]),
    ...mapActions({
      createTimeClock: "timeclock/createFromTask",
    }),

    initForm() {
      if (this.clientId) {
        this.form = {
          ...this.form,
          task: {
            ...this.form.task,
            clientId: this.clientId,
            time: "00:00:00"
          },
        };
      }
    },

    serverSideErrors(field) {
      return UTIL.gv(this.task.errors, field, []);
    },
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });

      this.initForm();
    },

    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
      };
    },
    completed() {
      this.$emit("onSucceded");
    },
    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        ...this.form,
        task: {
          ...this.form.task,
          date: moment(this.form.task.date).format('YYYY-MM-DD') + "T" + this.form.task.time 
        }        
      };

      if (this.isEdit) {
        await this.update({
          id: this.taskId,
          ...payload,
        });
      } else {
        delete payload.task.id;
        await this.create(payload);
        if (!this.task.status.error) {
          // await this.createTimeClock({
          //   id: this.task.single.id,
          //   ...payload,
          // });
        }
      }

      if (!this.task.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>